export default "__VITE_ASSET__DvacjZLj__"